import { render, staticRenderFns } from "./MSOCouponBase.vue?vue&type=template&id=35e3eb84&"
import script from "./MSOCouponBase.vue?vue&type=script&lang=js&"
export * from "./MSOCouponBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports